<template>
    <b-overlay class="rounded" opacity="0.2">
        <b-card no-body>
            <b-modal id="transaction-details" :title="'İşlem Detayları - ' + (selectedTransaction ? selectedTransaction.ProcessNumber : '')" no-close-on-esc no-close-on-backdrop body-class="p-0" size="xl">
                <FuelStorageTransactionDetail v-if="selectedTransaction" :transaction="selectedTransaction" :all-employees="allEmployees" :fuel-types="fuelTypeOptions" :vehicle-plates="vehiclePlateOptions" />
                <template #modal-footer>
                    <div></div>
                </template>
            </b-modal>

            <b-card v-if="pendingTransactionsList.length > 0" class="mb-2 border-warning">
                <h5 class="text-warning">Onay Bekleyen Yakıt Çıkışları</h5>
                <p class="small text-muted">Bu işlem için SMS onayı beklenmektedir. Tamamlamak veya yeni kod istemek için butona tıklayınız. Bu liste sayfa yenilendiğinde kaybolacaktır.</p>
                <div v-for="(item, index) in pendingTransactionsList" :key="item.ProcessNumber" class="d-flex justify-content-between align-items-center mb-1">
                    <span>
                        <feather-icon icon="FileTextIcon" class="mr-50" />
                        İşlem No: <strong>{{ item.ProcessNumber }}</strong>
                    </span>
                    <div>
                        @
                        <button class="btn btn-sm btn-warning" v-on:click="reopenSmsModal(item)">
                            <feather-icon icon="SendIcon" size="14" class="mr-50" />
                            Onay Kodu Gir / Yeniden Gönder
                        </button>
                    </div>
                </div>
            </b-card>
            <FuelTransferConfirmModal ref="confirmModal" @confirm="handleTransferConfirmation" />
            <v-table ref="table" :fields="fields" name="fuel-storage-transaction" :buttons="buttons" pagination="server" search :items-provider="provider" button-alignment="justify-content-start">
                <template #additional-actions>
                    <div class="transaction-toolbar w-100">
                        <div class="transaction-type-actions" role="group" aria-label="İşlem tipi hızlı filtreleri">
                            <button type="button" :class="['btn', filterModel.FuelTransactionType === null ? 'btn-primary' : 'btn-outline-dark']" v-on:click="setTransactionType(null)">Tüm Hareketler</button>
                            <button type="button" :class="['btn', filterModel.FuelTransactionType === 1 ? 'btn-success' : 'btn-outline-dark']" v-on:click="setTransactionType(1)">Yakıt Girişi</button>
                            <button type="button" :class="['btn', filterModel.FuelTransactionType === 0 ? 'btn-danger' : 'btn-outline-dark']" v-on:click="setTransactionType(0)">Yakıt Çıkışı</button>
                            <button type="button" :class="['btn', filterModel.FuelTransactionType === 3 ? 'btn-warning' : 'btn-outline-dark']" v-on:click="setTransactionType(3)">Transfer</button>
                            <button type="button" :class="['btn', filterModel.FuelTransactionType === 5 ? 'btn-info' : 'btn-outline-dark']" v-on:click="setTransactionType(5)">Stok Dengeleme</button>
                        </div>
                        <div class="transaction-toolbar__export">
                            <button v-b-tooltip.hover.bottom title="Dışa Aktar" class="btn btn-sm btn-icon rounded-circle btn-outline-success p-25" v-on:click="downloadExcel" :disabled="loading">
                                <feather-icon icon="ArrowDownIcon" size="12" />
                            </button>
                        </div>
                    </div>
                </template>
                <template #filters>
                    <div class="row">
                        <div class="col-12 col-md-6 col-xl-2">
                            <label>Başlangıç Tarihi</label>
                            <v-date-picker v-model="filterModel.StartDate" v-on:input="refreshTable()" />
                        </div>

                        <div class="col-12 col-md-6 col-xl-2">
                            <label>Bitiş Tarihi</label>
                            <v-date-picker v-model="filterModel.EndDate" v-on:input="refreshTable()" />
                        </div>
                        <div class="col-12 col-md-6 col-xl-2">
                            <label>İşlem Tipi</label>
                            <v-select
                                v-model="filterModel.FuelTransactionType"
                                :options="filterTransactionTypeOptions"
                                label="text"
                                :reduce="(item) => item.value"
                                placeholder="Tümü"
                                v-on:input="refreshTable()"
                            />
                        </div>
                        <div class="col-12 col-md-6 col-xl-2">
                            <label>Depo</label>
                            <v-select v-model="filterModel.FuelStorageId" :options="processedFuelStorageOptions" label="DisplayName" :reduce="(item) => item.Id" placeholder="Tümü" v-on:input="refreshTable()" />
                        </div>
                        <div class="col-12 col-md-6 col-xl-2">
                            <label>Yakıt Tipi</label>
                            <v-select v-model="filterModel.FuelStorageFuelTypeId" :options="fuelTypeOptions" label="text" :reduce="(item) => item.value" placeholder="Tümü" v-on:input="refreshTable()" />
                        </div>
                        <div class="col-12 col-md-6 col-xl-2 d-flex align-items-end">
                            <button type="button" class="btn btn-outline-secondary w-100 text-nowrap" v-on:click="clearFilters">Temizle</button>
                        </div>
                    </div>
                </template>
            </v-table>
        </b-card>
    </b-overlay>
</template>

<script>
import api from "@/api/fuel-storage";
import { VBTooltip, BCard, BOverlay, BFormRadioGroup } from "bootstrap-vue";
import Additional from "@/utilities/additional";
import EmployeeOperationsApi from "@/api/employee-operations";
import VehicleOperationsApi from "@/api/vehicle-operations";
import FuelStorageTransactionDetail from "./components/FuelStorageTransactionDetail.vue";
import SmsVerificationModalContent from "./components/SmsVerificationModalContent.vue";
import FuelTransferConfirmModal from "./components/FuelTransferConfirmModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    name: "FuelStorageTransactionView",
    components: {
        BCard,
        BOverlay,
        BFormRadioGroup,
        FuelStorageTransactionDetail,
        SmsVerificationModalContent,
        FuelTransferConfirmModal,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    data() {
        return {
            errors: {},
            editing: false,
            loading: false,
            employees: [],
            employeeLoading: false,
            globPayload: null,
            reportModalVisible: false,
            fuelOrderOptions: [],
            fuelStorageOptions: [],
            allEmployees: [],
            vehiclePlateOptions: [],
            fuelTypeOptions: [],

            warehouseFillingForm: {},
            fuelWithdrawalForm: {},

            smsVerificationCode: null,
            pendingFuelWithdrawal: null,
            pendingTransactionsList: [],

            selectedTransaction: null,
            selectedTransactionId: null,
            filterModel: {
                FuelTransactionType: null,
                StartDate: null,
                EndDate: null,
                FuelStorageId: null,
                FuelStorageFuelTypeId: null,
            },

            transactionTypeOptions: [
                { text: "Tüm Hareketler", value: null },
                { text: "Yakıt Girişi", value: 1 },
                { text: "Yakıt Çıkışı", value: 0 },
                { text: "Transfer", value: 3 },
                { text: "Stok Dengeleme", value: 5 },
                { text: "Araçtan Depoya Aktarım", value:6}
            ],
            excelPath: null,

            fields: [
                { name: "İşlem No", key: "ProcessNumber", sortable: true, thClass: "text-nowrap", tdClass: "text-nowrap w-14" },
                { name: "İşlem Tipi", key: "FuelTransactionTypeName", sortable: true, sortKey: "FuelTransactionType", thClass: "text-nowrap", tdClass: "text-nowrap w-13" },
                { name: "Yakıt Tipi", key: "FuelTypeName", sortable: false, thClass: "text-nowrap", tdClass: "text-nowrap", component: true, componentOptions: { name: "fuel-storage/FuelTypeBadge" } },
                {
                    name: "Sipariş No",
                    key: "OrderNumber",
                    sortable: false,
                    thClass: "text-nowrap",
                    tdClass: "text-nowrap",
                    component: true,
                    componentOptions: { name: "fuel-storage/OrderNumberCell" },
                },
                {
                    name: "Sipariş Durumu",
                    key: "OrderStatusName",
                    sortable: false,
                    thClass: "text-nowrap",
                    tdClass: "text-nowrap",
                    component: true,
                    componentOptions: { name: "fuel-storage/OrderStatusBadge" },
                },
                { name: "Depo", key: "StorageNames", sortable: false, thClass: "text-nowrap", tdClass: "text-nowrap", component: true, componentOptions: { name: "fuel-storage/TransferRouteCell" } },
                {
                    name: "Miktar [lt]",
                    key: "IncomingQuantityStr",
                    thClass: "text-nowrap",
                    tdClass: "text-nowrap text-right w-14",
                    component: true,
                    componentOptions: { name: "fuel-storage/QuantityCell" },
                },
                { name: "Tarih", key: "CreateTime", sortable: true, thClass: "text-nowrap", tdClass: "text-nowrap w-5" },
                { name: "İşlemi Yapan", key: "EmployeeFullName", sortable: false, thClass: "text-nowrap", tdClass: "text-nowrap w-10" },

            ],
            buttons: [
                { text: "Görüntüle", key: "view", icon: "EyeIcon", variant: "info", action: this.showDetails },
                {
                    text: "Düzenle",
                    key: "edit",
                    icon: "EditIcon",
                    variant: "warning",
                    action: this.editTransaction,
                    condition: (row) => {
                        // Yalnızca Yakıt Girişi (1) ve Yakıt Çıkışı (0) düzenlenebilir.
                        // Transfer, Stok Dengeleme, Araçtan Depoya tipleri için Update backend'de
                        // tam reversal uygulamıyor — bunlar için sil + yeniden oluştur akışı kullanılmalı.
                        if (row.FuelTransactionType !== 0 && row.FuelTransactionType !== 1) return false;
                        if (row.FuelTransactionType === 1 && row.OrderStatusName === "Kapatıldı") return false;
                        return true;
                    },
                },
                {
                    text: "Sil",
                    key: "delete",
                    icon: "TrashIcon",
                    variant: "danger",
                    action: this.delete,
                    condition: (row) => {
                        if (row.FuelTransactionType === 3) return false;
                        if (row.FuelTransactionType === 1) {
                            return row.OrderStatusName !== "Kapatıldı";
                        }
                        return true;
                    },
                },
                {
                    text: "Onayla",
                    key: "approve",
                    icon: "CheckCircleIcon",
                    variant: "success",
                    action: this.approveTransfer,
                    condition: (row) => {
                        if (row.FuelTransactionType !== 3) return false;

                        const details = row.FuelStorageTransferTransactionDetails;
                        if (!details || !Array.isArray(details)) return false;

                        return details.some((d) => d.TransactionType === 1 && d.IsConfirmed === false);
                    },
                },
            ],
        };
    },
    mounted() {
        this.loadOptions();
    },
    computed: {
        isWarehouseFillingFormInvalid() {
            const form = this.warehouseFillingForm;
            if (!form || !form.FuelOrderId || !form.FuelStorageTransactionDetails) return true;

            const totalDistributed = form.FuelStorageTransactionDetails.reduce((sum, dist) => sum + (Number(dist.Quantity) || 0), 0);

            return !form.FuelOrderId || totalDistributed <= 0;
        },
        smsModalSummary() {
            if (!this.pendingFuelWithdrawal) {
                return {};
            }

            const vehicle = this.vehiclePlateOptions.find((v) => v.Id === this.pendingFuelWithdrawal.VehiclePlateId);
            const trailer = this.vehiclePlateOptions.find((v) => v.Id === this.pendingFuelWithdrawal.TrailerPlateId);

            const driver = this.allEmployees.find((e) => e.Id === this.pendingFuelWithdrawal.FuelStorageTransactionDetails[0]?.DriverEmployeeId);

            const fuelDetails = this.pendingFuelWithdrawal.FuelStorageTransactionDetails.map((detail) => {
                const fuelType = this.fuelTypeOptions.find((ft) => ft.value === detail.FuelTypeId);
                const depot = this.fuelStorageOptions.find((fs) => fs.Id === detail.FuelStorageId);
                return {
                    fuelTypeName: fuelType ? fuelType.text : "Bilinmiyor",
                    depotName: depot ? depot.Name : "Bilinmiyor",
                    quantity: (Number(detail.Quantity) || 0).toFixed(2),
                };
            });

            const totalQuantity = this.pendingFuelWithdrawal.FuelStorageTransactionDetails.reduce((sum, detail) => {
                return sum + (Number(detail.Quantity) || 0);
            }, 0);

            return {
                processNumber: this.pendingFuelWithdrawal.ProcessNumber,
                plate: this.pendingFuelWithdrawal.VehiclePlateValue || "Bulunamadı",
                trailerPlate: trailer ? trailer.PlateValue : null,
                driverName: driver ? driver.FullName : "Bulunamadı",
                vehicleKM: this.pendingFuelWithdrawal.VehicleCurrentKM,
                details: fuelDetails,
                totalQuantity: totalQuantity.toFixed(2),
            };
        },
        processedFuelStorageOptions() {
            return this.fuelStorageOptions.map((storage) => ({
                ...storage,
                DisplayName: `${storage.Name} [${(storage.Capacity || 0).toLocaleString("tr-TR")} lt]`,
            }));
        },
        filterTransactionTypeOptions() {
            return this.transactionTypeOptions.filter((item) => item.value !== null && item.value !== 6);
        },
        isFuelWithdrawalFormInvalid() {
            const form = this.fuelWithdrawalForm;
            if (!form || !form.FuelStorageTransactionDetails) {
                return true;
            }
            if (!form.VehiclePlateId || !form.DriverEmployeeId) {
                return true;
            }

            const isAnyDetailInvalid = form.FuelStorageTransactionDetails.some((detail) => {
                if (!detail.FuelTypeId || !detail.FuelStorageId || (detail.Quantity || 0) <= 0) {
                    return true;
                }

                return false;
            });

            return isAnyDetailInvalid;
        },
    },

    methods: {
        refreshTable(resetPage = false) {
            const table = this.$refs.table;
            if (!table) return;

            if (resetPage && typeof table.setPage === "function") {
                table.setPage(1);
            }

            table.refresh();
        },
        setTransactionType(type) {
            this.filterModel.FuelTransactionType = type;
            this.refreshTable();
        },
        clearFilters() {
            this.filterModel = {
                FuelTransactionType: null,
                StartDate: null,
                EndDate: null,
                FuelStorageId: null,
                FuelStorageFuelTypeId: null,
            };

            if (this.$refs.table) {
                this.$refs.table.searchValue = "";
            }

            this.refreshTable(true);
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        loadOptions() {
            Promise.all([this.loadAllEmployees(), this.loadFuelOrderOptions(), this.loadFuelStorageOptions(), this.loadVehiclePlates(), this.loadFuelTypeOptions()]).catch((err) => {
                console.error("Dropdown verileri yüklenirken bir hata oluştu:", err);

                this.$result(null, "Dropdown seçenekleri yüklenirken bir hata oluştu.");
            });
        },

        loadFuelTypeOptions() {
            this.fuelTypeOptions = [
                { text: "Motorin", value: "3a82d544-bfda-4995-ad74-29982d9606df" },
                { text: "AdBlue", value: "b8694977-e4fc-4c90-b02f-d7bc04caa146" },
            ];
            return Promise.resolve();
        },
        loadAllEmployees() {
            return EmployeeOperationsApi.Employee.List().then((res) => {
                if (res.data.Success) {
                    this.allEmployees = res.data.Data || [];
                }
            });
        },

        loadFuelOrderOptions() {
            return api.FuelOrder.List(true).then((res) => {
                if (res.data.Success) {
                    const orders = res.data.Data || [];
                    this.fuelOrderOptions = orders.map((order) => {
                        return {
                            ...order,
                            displayText: `${order.OrderNumber} - ${order.FuelOrderBranch}`,
                        };
                    });
                }
            });
        },

        loadVehiclePlates() {
            return VehicleOperationsApi.Plate.ListViaStatus(true).then((res) => {
                if (res.data.Success) {
                    this.vehiclePlateOptions = res.data.Data || [];
                }
            });
        },
        loadFuelStorageOptions() {
            return api.FuelStorage.List().then((res) => {
                if (res.data.Success) {
                    this.fuelStorageOptions = res.data.Data || [];
                }
            });
        },
        searchEmployees(search) {
            if (search && search.length > 1) {
                this.employeeLoading = true;
                EmployeeOperationsApi.Employee.SearchActiveDriver(search)
                    .then((res) => {
                        if (res.data.Success) {
                            this.employees = res.data.Data || [];
                        }
                    })
                    .catch((err) => {
                        this.$result(null, err);
                    })
                    .finally(() => {
                        this.employeeLoading = false;
                    });
            }
        },

        downloadExcel() {
            this.excelPath = null;
            api.ExcelReport.ExportFuelStorageTransactionReport(this.globPayload)
                .then((res) => {
                    if (res.data.Success) {
                        this.excelPath = res.data.Data;
                        this.$result(res);

                        if (this.excelPath) {
                            Additional.DownloadTab(this.excelPath);
                        }
                    } else {
                        this.$result(res);
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                });
        },
        provider(data) {
            const payload = {
                PaginationRequestModel: data,
                ...this.filterModel,
            };
            this.globPayload = payload;
            return api.FuelStorageTransaction.Datatable(payload);
        },
        delete(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem ${item.ProcessNumber} işlem numaralı hareket kaydını silecektir ve geri alınamaz.`).then((result) => {
                if (result) {
                    api.FuelStorageTransaction.Delete(item.Id)
                        .then((res) => {
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                            this.$result(res);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },

        showDetails(row) {
            this.selectedTransaction = row;
            this.selectedTransactionId = row.Id;
            this.$showModal("transaction-details");
        },
        editTransaction(row) {
            // Giriş (1) → FuelFillingPage; Çıkış (0) → FuelWithdrawalPage
            const targetRoute = row.FuelTransactionType === 1 ? "fuel-storage-filling" : "fuel-storage-withdrawal";
            this.$router.push({ name: targetRoute, query: { transactionId: row.Id } });
        },
        modalTitle() {
            if (!this.selectedTransaction) {
                return "İşlem Detayları";
            }

            const typeName = this.selectedTransaction.FuelTransactionTypeName || "";
            const processNumber = this.selectedTransaction.ProcessNumber || "";

            return `${typeName} İşlem Detayları - ${processNumber}`;
        },
        approveTransfer(row) {
            const targetDetail = row.FuelStorageTransferTransactionDetails && row.FuelStorageTransferTransactionDetails.find((d) => d.TransactionType === 1 && d.IsConfirmed === false);
            const sourceDetail = row.FuelStorageTransferTransactionDetails && row.FuelStorageTransferTransactionDetails.find((d) => d.TransactionType === 0);

            if (!targetDetail) {
                this.$toast({
                    component: ToastificationContent,
                    props: { title: "Hata", icon: "AlertCircleIcon", variant: "danger", text: "Onaylanacak detay kaydı bulunamadı." },
                });
                return;
            }

            if (!targetDetail.Id) {
                this.$toast({
                    component: ToastificationContent,
                    props: { title: "İşlem Yapılamadı", icon: "AlertCircleIcon", variant: "warning", text: "Transfer kimlik bilgisi eksik." },
                });
                return;
            }

            this.$refs.confirmModal.open(targetDetail, sourceDetail, row.ProcessNumber, row.FuelTypeName, targetDetail.TargetBranchId);
        },
        handleTransferConfirmation(data) {
            const formData = new FormData();
            formData.append("FuelStorageTransferTransactionDetailId", data.id);
            formData.append("Tonnage", String(data.Tonnage).replace(".", ","));
            formData.append("Density", String(data.Density).replace(".", ","));
            formData.append("ConfirmQuantity", String(data.ConfirmQuantity).replace(".", ","));

            if (data.FuelStorageId) {
                formData.append("FuelStorageId", data.FuelStorageId);
            }
            if (data.File) {
                formData.append("File", data.File);
            }

            this.loading = true;

            api.FuelStorageTransaction.ConfirmTransfer(formData)
                .then((res) => {
                    if (res.data.Success) {
                        this.$toast({
                            component: ToastificationContent,
                            props: { title: "Başarılı", icon: "CheckCircleIcon", variant: "success", text: "Transfer başarıyla onaylandı." },
                        });
                        this.$refs.table.refresh();
                        this.$refs.confirmModal.hide();
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            props: { title: "Hata", icon: "AlertCircleIcon", variant: "danger", text: res.data.Message || "İşlem başarısız." },
                        });
                        this.$refs.confirmModal.loading = false;
                    }
                })
                .catch((err) => {
                    this.$toast({
                        component: ToastificationContent,
                        props: { title: "Hata", icon: "AlertCircleIcon", variant: "danger", text: "Sunucu hatası oluştu." },
                    });
                    this.$refs.confirmModal.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped>
.d-flex.gap-2 > * {
    margin-right: 0.5rem;
}

.d-flex.gap-2 > *:last-child {
    margin-right: 0;
}

.transaction-toolbar {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.transaction-type-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.transaction-type-actions .btn {
    white-space: nowrap;
}

.transaction-toolbar__export {
    margin-left: auto;
    display: flex;
    align-items: center;
}

@media (max-width: 991px) {
    .transaction-type-actions {
        overflow-x: auto;
        flex-wrap: nowrap;
        width: 100%;
        padding-bottom: 0.25rem;
    }

    .transaction-toolbar__export {
        margin-left: 0;
        width: 100%;
        justify-content: flex-end;
    }
}
</style>
